import { FC, useEffect, useState } from 'react'
import { Auth } from '@aws-amplify/auth'
import { Card } from '../../../components/Card'
import { qrMenuPOST } from 'featureSliced/shared/api/qrMenu/POST'
import { DataTrans } from '../../../components/Checkout/DataTrans'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { RenderIf } from 'components/RenderIf'
import { Spinner } from 'featureSliced/entities/Spinner'
import { Button } from 'featureSliced/entities/Button'
import { CardMargin } from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { useAdyen } from 'featureSliced/shared/hooks/useAdyen/useAdyen'
import { ToastsSlice } from 'featureSliced/shared/store/reducers/ToasterReducer'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'

type CardDataType = {
  brand?: string
  cardNumber: string
  dueDate?: string
}

export const Payment: FC = () => {
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const openToast = ToastsSlice.actions.openToast
  //////
  const isDatatransActivated = useMySelector((state) => {
    return state.app.companyData.DatatransActivated
  })

  const paymentProvider = useMySelector(
    (state) => state.app.paymentConfig?.paymentProviderType
  )

  const adyenShopId = useMySelector(
    (state) => state.app.paymentConfig?.hsPay?.shopId
  )
  /////

  const [isLoading, setIsLoading] = useState(false)
  const [isButtonLoading, setIsButtonLoading] = useState(false)

  const [paymentId, setPaymentId] = useState<string | null>(null)
  const [cardData, setCardData] = useState<CardDataType>({
    cardNumber: '',
    dueDate: '',
  })

  useEffect(() => {
    loadCards()
  }, [])

  const loadCards = async () => {
    try {
      setIsLoading(true)
      if (isDatatransActivated) {
        const currentUserInfo = await Auth.currentUserInfo()
        const attributes = currentUserInfo?.attributes
        if (attributes) {
          if (attributes?.['custom:active_card_token']) {
            const originalData = JSON.parse(
              attributes?.['custom:active_card_token']
            )
            setCardData({
              cardNumber: originalData.masked,
              dueDate:
                originalData.expiryMonth && originalData.expiryYear
                  ? `${originalData.expiryMonth}/${originalData.expiryYear}`
                  : undefined,
            })
          }
        }
      } else if (paymentProvider === 3 && adyenShopId?.length) {
        const adyenPaymentMethods = await qrMenuGET.adyenPaymentMethods(
          adyenShopId
        )
        const storedPaymentMethods =
          adyenPaymentMethods?.storedPaymentMethods?.[0]
        setCardData({
          brand: storedPaymentMethods?.brand,
          cardNumber: storedPaymentMethods?.lastFour
            ? `**** **** **** ${storedPaymentMethods?.lastFour}`
            : '',
          dueDate:
            storedPaymentMethods?.expiryMonth &&
            storedPaymentMethods?.expiryYear
              ? `${storedPaymentMethods?.expiryMonth}/${storedPaymentMethods?.expiryYear}`
              : '',
        })
      }
    } catch (e) {
      console.log('Error:', e)
    } finally {
      setIsLoading(false)
    }
  }

  ////

  const startAdyen = useAdyen()

  const requestTransactionIdForNewCard = async () => {
    try {
      setIsLoading(true)
      if (paymentProvider === 3 && adyenShopId?.length) {
        const callHsPay = async (shopId?: string, hsPaymentData?: any) => {
          const result = await qrMenuPOST.createNewPaymentVariant(
            shopId,
            hsPaymentData
          )
          return result
        }
        startAdyen(
          0, // value. Must be 0 for CC update.
          async (hsPaymentData: any) => callHsPay(adyenShopId, hsPaymentData), // createPayment
          async (transactionId: string | null) => {
            const complereResult = await qrMenuPOST.completeNewPaymentVariant(
              transactionId as string
            )
            if (complereResult?.paymentKey) {
              await loadCards()
            } else {
              dispatch(
                openToast({
                  message: t('errors.smthWentWrong'),
                  type: 'error',
                })
              )
            }
            setIsLoading(false)
          }, // completePayment
          true // isPaymentMethodUpdate
        )
      } else {
        // TODO: check if it works / or if it should work with saferPay
        setIsButtonLoading(true)
        const { transactionId } = await qrMenuPOST.createNewPaymentVariant()
        setPaymentId(transactionId)
      }
    } catch (e) {
      console.log('Error:', e)
      setIsLoading(false)
    }
  }

  ////

  return (
    <>
      <RenderIf condition={isLoading}>
        <Spinner type="transparent" />
      </RenderIf>
      <RenderIf condition={!!paymentId}>
        <DataTrans transactionId={paymentId as string} />
      </RenderIf>
      <RenderIf condition={!isLoading}>
        <CardMargin />
        <Card {...cardData} />
        <br />
        <RenderIf condition={navigator.onLine}>
          <Button
            buttonType="common"
            width="100%"
            isLoading={isButtonLoading}
            onClick={requestTransactionIdForNewCard}
          >
            {t('profile.addNewPaymentMethod')}
          </Button>
        </RenderIf>
      </RenderIf>
    </>
  )
}
